import { useNavigate } from '@solidjs/router';
import { Show, createEffect } from 'solid-js';
import { state } from '../lib/app';

/** Landing page for the OAuth redirect. supabase-js exchanges the ?code= itself. */
export default function AuthCallback() {
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search + location.hash.replace(/^#/, '&'));
  const error = params.get('error_description') ?? params.get('error');
  createEffect(() => {
    if (state.session()) navigate('/', { replace: true });
  });
  return (
    <div class="signin">
      <div class="signin-card">
        <Show when={error} fallback={<p class="lede">Signing you in…</p>}>
          <h1>Sign-in didn’t complete</h1>
          <p class="form-error">{error}</p>
          <a class="btn" href="/">
            Try again
          </a>
        </Show>
      </div>
    </div>
  );
}
